export default __webpack_public_path__ + "static/media/Step1.30ef172f.jpg";